/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExchangeRateResponseApiResponse } from '../../models/exchange-rate-response-api-response';

export interface GetLiveExchangeRateQuery$Plain$Params {
  BaseCurrency?: string;
  Symbols?: Array<string>;
}

export function getLiveExchangeRateQuery$Plain(http: HttpClient, rootUrl: string, params?: GetLiveExchangeRateQuery$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExchangeRateResponseApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getLiveExchangeRateQuery$Plain.PATH, 'get');
  if (params) {
    rb.query('BaseCurrency', params.BaseCurrency, {});
    rb.query('Symbols', params.Symbols, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExchangeRateResponseApiResponse>;
    })
  );
}

getLiveExchangeRateQuery$Plain.PATH = '/api/rates/live';
